import useScrollReveal from "./shared/useScrollReveal";

const STATS = [
  { num: "5000+", label: "Chargers Deployed" },
  { num: "15+", label: "States Covered" },
  { num: "24/7", label: "Real Time Monitoring" },
  { num: "99.2%", label: "Network Uptime" },
];

export default function ProofBand() {
  const ref = useScrollReveal();

  return (
    <div className="proof-band" ref={ref}>
      <div className="containers-min mx-auto px-4 py-12">
        <h5 className="font-bold reveal" style={{ textAlign: "center", marginBottom: 32 }}>
          VerdeMobility in Numbers
        </h5>
        <div className="proof-grid">
          {STATS.map((s) => (
            <div className="proof-item reveal" key={s.label}>
              <div className="proof-num">{s.num}</div>
              <div className="proof-label">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
